import { useMemo } from 'react';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { VStack } from '@cbhq/cds-web/layout/VStack';
import { Interactable } from '@cbhq/cds-web/system';

import { useManageAccountNavigation } from '../hooks/useManageAccountNavigation';

import { ManagedByBanner } from './ManagedByBanner';
import { ProfileHeaderContent } from './ProfileHeaderContent';

export function ProfileHeader() {
  const handlePress = useManageAccountNavigation();

  const padding = useMemo(() => {
    return {
      phone: 0 as const,
      tablet: 1 as const,
      desktop: 1 as const,
    };
  }, []);

  return (
    <VStack>
      <ManagedByBanner />
      <HStack padding={padding} tabIndex={0}>
        <Interactable
          as="button"
          background="bg"
          onClick={handlePress}
          width="100%"
          borderRadius={100}
        >
          <ProfileHeaderContent />
        </Interactable>
      </HStack>
    </VStack>
  );
}
